export default __webpack_public_path__ + "media/images/dashed-line-md-dc0daabbe9e86851949df07ad38f43e5.svg";